import cogoToast from "cogo-toast";
import httpRequest from "../../ajax";
import {
  APPLY_TO_JOB,
  CREATE_JOB,
  CREATE_JOB_UPLOAD_EXCEL,
  EDIT_JOB,
  SUSPEND_JOB,
  DELETE_SAVED_JOBS,
  DELETE_JOBS,
  POST_JOB_VALIDATION,
  POST_HIRING,
  POST_PERFORMANCE,
  POST_EMPLOYEEPERFORMANCE,
  POST_SENDBACK,
  ERROR,
  GET_STATUS,
  POST_EDITED_PERFORMANCE,
  GET_ALL_JOBS,
  GET_PERFORMANCE,
  GET_EACHPERFORMANCE,
  GET_JOB_NO_AUTH,
  GET_OFFERS_JOBS,
  GET_APPLIED,
  GET_JOB,
  GET_JOB_LIST,
  GET_JOB_LEVELS,
  GET_MY_JOBS,
  GET_SAVED_JOBS,
  RESET_JOB_CREATED,
  SAVE_JOB,
  REPORT_JOB,
  SEARCH_JOBS,
  SEARCH_JOBS_LOADING,
  // LIKE_UNLIKE_JOB,
  GET_REFERRAL_JOBS,
  RESET_JOBS,
  GET_ADMIN_JOBS,
  APPLY_TO_RECRUITER_JOB,
  RECRUIT_REQUESTS,
  RECRUIT_REQUESTS_BY_JOBS,
  GET_BUSINESS_JOB,
  GET_VERIFICATION, //
  GET_EMPLOYEE,
} from "../actionTypes";
import { getJobSearchFiltersFromLLM } from "../../services/nlpSearchHelper";

export const createJobRequest = (data) => {
  return httpRequest("post", "/jobs/create", data);
};

export const createJobAction = (dispatch, data) => {
  return createJobRequest(data)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_JOB, payload: data };
      dispatch(action);
      cogoToast.success("Job created successfully!");
      getJobsAction(dispatch, 1);
      // Add delay to allow toast to show before redirect
      setTimeout(() => {
        window.location.href = "/myjobs";
      }, 1500);
      return action;
    })
    .catch(({ response }) => {
      const errorAction = {
        payload:
          response?.data?.message || "An error occurred while creating the job",
        type: ERROR,
      };
      dispatch(errorAction);
      const msg = (response?.data?.message || "").toLowerCase();
      const suppressToastForWallet =
        msg.includes("insufficient wallet balance") ||
        msg.includes("wallet not found");
      if (!suppressToastForWallet) {
        cogoToast.error(response?.data?.message || "Failed to create job");
      }
      // Reject the promise so callers' .catch handlers run and accidental redirects are avoided
      return Promise.reject(response);
    });
};
export const getStatus = (dispatch, user_id) => {
  return httpRequest("post", "/jobs/check-status", { user_id })
    .then(({ data }) => {
      const action = { type: GET_STATUS, payload: data };
      dispatch(action);

      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};
export const postJobValidation = (dispatch, data) => {
  return httpRequest("post", "/jobs/validate", data)
    .then(({ data }) => {
      const action = { type: POST_JOB_VALIDATION, payload: data };
      dispatch(action);

      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const createJobFromExcelAction = (dispatch, data) => {
  httpRequest("post", "/jobs/create/xls", data)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_JOB_UPLOAD_EXCEL, payload: data };
      dispatch(action);
      getJobsAction(dispatch, 1);
      window.location.href = "/myjobs";
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const editJobAction = (dispatch, data) => {
  // alert("**###=====editJobAction===="+JSON.stringify(data));

  return httpRequest("post", `/jobs/${data.id}/update`, data)
    .then(({ data: { data } }) => {
      const action = { type: EDIT_JOB, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const errorAction = {
        payload: response?.data?.message || "Failed to update job",
        type: ERROR,
      };
      dispatch(errorAction);
      return Promise.reject(response);
    });
};

export const suspendJob = (dispatch, job_id) => {
  return httpRequest("post", `/jobs/${job_id}/suspend`, {})
    .then(({ data: { data } }) => {
      const action = { type: SUSPEND_JOB, payload: data };
      dispatch(action);
      cogoToast.success("Job status updated successfully!");
      return action;
    })
    .catch(({ response }) => {
      const error = {
        payload: response?.data?.message,
        type: ERROR,
      };
      cogoToast.error(response?.data?.message || "Failed to update job status");
      return error;
    });
};

export const closeJob = (dispatch, job_id) => {
  return httpRequest("post", `/jobs/${job_id}/close`, {})
    .then(({ data: { data } }) => {
      const action = { type: SUSPEND_JOB, payload: data };
      dispatch(action);
      cogoToast.success("Job closed successfully!");
      return action;
    })
    .catch(({ response }) => {
      const error = {
        payload: response?.data?.message,
        type: ERROR,
      };
      cogoToast.error(response?.data?.message || "Failed to close job");
      return error;
    });
};

export const getEitherJob = (dispatch, jobId, isBusiness = false) => {
  if (isBusiness) {
    // console.log("I am isBusiness");
    getBusinessJob(dispatch, jobId);
  } else {
    getJob(dispatch, jobId);
  }
};

export const getJobListAction = (dispatch) => {
  httpRequest("get", `/all-job-list`)
    .then(({ data: { data } }) => {
      console.log(
        "############==getJobListAction==############" + JSON.stringify(data),
      );

      const action = { type: GET_JOB_LIST, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getJob = (dispatch, id) => {
  httpRequest("get", `/jobs/${id}`)
    .then(({ data: { data } }) => {
      //console.log("############==getJob==############"+JSON.stringify(data));
      const action = { type: GET_JOB, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getJobNoAuthAction = (dispatch, id) => {
  httpRequest("get", `/jobs/noauth/${id}`)
    .then(({ data: { data } }) => {
      console.log("############==getJob==############" + JSON.stringify(data));
      const action = { type: GET_JOB_NO_AUTH, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const clearJobCreated = (dispatch) =>
  dispatch({ type: RESET_JOB_CREATED });

export const setLocationFilterAction = (dispatch, filter) =>
  dispatch({ type: "SET_LOCATION_FILTER", payload: filter });

export const getJobsAction = (dispatch, page, jobsPerPage, filters = {}, locationFilter = null) => {
  const params = new URLSearchParams();

  if (filters.jobTier && filters.jobTier !== '') params.append('job_tier', filters.jobTier);
  if (filters.datePosted && filters.datePosted !== '') params.append('date_posted', filters.datePosted);
  // Only send job_type if not all 3 values selected (all selected = no restriction)
  if (filters.jobType && Array.isArray(filters.jobType) && filters.jobType.length > 0 && filters.jobType.length < 3) params.append('job_type', filters.jobType.join(','));
  if (filters.experienceLevel && Array.isArray(filters.experienceLevel) && filters.experienceLevel.length > 0) params.append('experience_level', filters.experienceLevel.join(','));
  if (filters.city && filters.city !== '') params.append('city', filters.city);
  if (filters.skills && Array.isArray(filters.skills) && filters.skills.length > 0) params.append('skills', filters.skills.join(','));

  // Modal country/region filters override the toolbar locationFilter
  if (filters.countryId && filters.countryId !== '') {
    params.append('country_id', filters.countryId);
  } else if (filters.region && filters.region !== '') {
    params.append('region', filters.region);
  } else if (locationFilter) {
    if (locationFilter.type === "country") params.append('country_id', locationFilter.value);
    else params.append('region', locationFilter.value);
  }

  const queryString = params.toString();
  const url = queryString
    ? `/jobs/${page}/${jobsPerPage}?${queryString}`
    : `/jobs/${page}/${jobsPerPage}`;

  return httpRequest("get", url)
    .then(({ data: { data, total_item_count } }) => {
      const action = { type: GET_ALL_JOBS, payload: data };
      dispatch(action);
      return {
        total: Number(data.total_item_count),
        dataLength: Array.isArray(data[0]) ? data[0].length : 0,
        action,
      };
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};
export const getJobsRecommendationAction = (dispatch, page, JobPage) =>
  httpRequest("get", `/jobs/suggesstions/${page}/${JobPage}`)
    .then(({ data: { data, total_item_count } }) => {
      const action = { type: GET_ALL_JOBS, payload: data };

      dispatch(action);
      return { total: Number(data.total_item_count), action };
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getAIJobsRecommendationAction = async (dispatch, userId) => {
  try {
    const { recommendJobs } = await import("../../services/matchScoreService");
    const response = await recommendJobs({
      user_id: 41,
    });

    console.log("AI Recom Response", response);

    if (response.status == "success") {
      const action = {
        type: GET_ALL_JOBS,
        payload: {
          0: response.recommendations
        },
      };
      dispatch(action);
      return { total: response.count, action };
    } else {
      return { type: ERROR, payload: response.error };
    }
  } catch (error) {
    return { type: ERROR, payload: error.message };
  }
};

export const getOffersAction = (
  dispatch,
  //,page
) =>
  httpRequest("get", `/insiight/jobOffers`)
    .then(({ data: { data } }) => {
      // console.log("Offers", data);
      const action = { type: GET_OFFERS_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const resetAllJobs = (dispatch) => dispatch({ type: RESET_JOBS });

export const getMyJobsAction = (dispatch) =>
  httpRequest("get", "/jobs/byMe/1/1000")
    .then(({ data: { data } }) => {
      const action = { type: GET_MY_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getJobLevelsAction = (dispatch) =>
  httpRequest("get", "/jobs/levels")
    .then(({ data: { data } }) => {
      const action = { type: GET_JOB_LEVELS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getApplications = (dispatch) =>
  httpRequest("get", "/jobs/application")
    .then(({ data: { data } }) => {
      const action = { type: GET_APPLIED, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getSavedJobs = (dispatch, page) =>
  httpRequest("get", `/jobs/saved/${page}/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_SAVED_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getRecruiterRequestsJobs = (dispatch) =>
  httpRequest("get", `/jobs/requestToRecruit/recruiter`)
    .then(({ data: { data } }) => {
      const action = { type: RECRUIT_REQUESTS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const changeRequestStatus = (id, option, action) =>
  httpRequest("put", `/jobs/requestToRecruit/${id}/${option}`)
    .then(() => {
      return action();
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getRecruitRequestsByJobs = (dispatch, id) =>
  httpRequest("get", `/jobs/requestToRecruit/${id}`)
    .then(({ data: { data } }) => {
      const action = { type: RECRUIT_REQUESTS_BY_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });
export const recruitRequest = (id) =>
  httpRequest("post", `/jobs/requestToRecruit/${id}`)
    .then(() => {
      return;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const saveJobAction = (dispatch, job_id) =>
  httpRequest("post", "/jobs/saved/create", { job_id })
    .then(({ data: { data } }) => {
      const action = { type: SAVE_JOB, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

// report job
export const reportJobAction = (dispatch, job_id, reason) => {
  const data = {
    job_id: job_id,
    reason: reason,
  };

  httpRequest("post", "/jobs/reportPost", data)
    .then(({ data: { data } }) => {
      const action = { type: REPORT_JOB, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const applyAction = (dispatch, job_id, refCode, c_id, func) => {
  const url = c_id
    ? `/jobs/application/create/${c_id}`
    : "/jobs/application/create";
  return httpRequest("post", url, { job_id, refCode })
    .then(({ data: { data } }) => {
      const action = { type: APPLY_TO_JOB, payload: data };
      dispatch(action);
      cogoToast.success("Application submitted successfully!");
      func();
      return action;
    })
    .catch(({ response }) => {
      cogoToast.error(response?.data?.message || "Failed to submit application");
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });
};

// Apply to recuiter's jobs
export const applyToRecruiterJob = (dispatch, job_id, recruiterId, func) => {
  // console.log("Applying to Recruiters Jobs");
  const rData = {
    job_id: parseInt(job_id, 10),
    recruiterId: parseInt(recruiterId, 10),
  };

  return httpRequest("post", "/jobs/application/applyToRercruiterJob", rData)
    .then(({ data: { data } }) => {
      const action = { type: APPLY_TO_RECRUITER_JOB, payload: data };
      dispatch(action);
      cogoToast.success("Application submitted successfully!");
      func();
      return action;
    })
    .catch(({ response }) => {
      cogoToast.error(response?.data?.message || "Failed to submit application");
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });
};

export const searchJobAction = async (dispatch, term, navigate = () => {}, locationFilter = null) => {
  try {
    console.log(" [SEARCH] Starting search with term:", term);

    // Dispatch loading state
    dispatch({ type: SEARCH_JOBS_LOADING, payload: true });

    const trimmedTerm = (term || "").trim();
    console.log(" [SEARCH] Trimmed term:", trimmedTerm);

    // 1. Try to get AI filters
    console.log(" [SEARCH] Calling getJobSearchFiltersFromLLM...");
    let filters = await getJobSearchFiltersFromLLM(trimmedTerm);
    console.log(" [SEARCH] LLM filters result:", filters);

    // 2. FALLBACK: If AI fails or returns null, build a manual filter object
    // This prevents the "bool" error on the backend by ensuring filters is always an object
    if (!filters || typeof filters !== "object") {
      console.warn(" [SEARCH] LLM failed, using fallback search");
      filters = {
        role_title: trimmedTerm, // Map the generic term to role_title
        sort: "latest"
      };
    }

    // Always include the raw term so the backend can do smart fallback / broad matching
    // without relying on the LLM-expanded wording.
    filters.__raw = trimmedTerm;

    // 3. Ensure a sort key exists
    if (!filters.sort) {
      filters.sort = "latest";
    }

    console.log(" [SEARCH] Final filters object:", filters);

    // 4. Determine a display term for the UI
    // For short queries, show exactly what the user typed (don't show LLM-expanded titles)
    const searchTerm =
      (trimmedTerm.length > 0 && trimmedTerm.length <= 3)
        ? trimmedTerm
        : (filters.role_title ||
          filters.skills_required?.[0] ||
          filters.campany_name ||
          term);

    // UI location filter takes priority over LLM-extracted location
    if (locationFilter) {
      if (locationFilter.type === "region") {
        filters.region = locationFilter.value;
        delete filters.is_global_role;
      } else if (locationFilter.type === "country") {
        filters.country_id = locationFilter.value;
        delete filters.region;
        delete filters.is_global_role;
      }
    }

    const searchParams = encodeURIComponent(JSON.stringify(filters));
    console.log(" [SEARCH] Encoded search params:", searchParams);

    const apiUrl = `/jobs/${searchParams}/search`;
    console.log(" [SEARCH] API URL:", apiUrl);

    console.log(" [SEARCH] Making API request...");
    const response = await httpRequest("get", apiUrl);
    console.log(" [SEARCH] Raw API response:", response);

    // Check if response data exists
    if(!response.data || !response.data.data) {
        console.error(" [SEARCH] Invalid response structure:", response.data);
        throw new Error("Invalid response from server");
    }

    const { data } = response.data;
    console.log(" [SEARCH] Extracted data:", data);

    navigate();
    const action = { type: SEARCH_JOBS, payload: { data, term: searchTerm } };
    console.log(" [SEARCH] Dispatching action:", action);

    dispatch(action);
    return action;

  } catch(error) {
      console.error(" [SEARCH] Search Error:", error);
      console.error(" [SEARCH] Error response:", error?.response);
      console.error(" [SEARCH] Error response data:", error?.response?.data);

      // Clear loading state on error
      dispatch({ type: SEARCH_JOBS_LOADING, payload: false });
      return {
        payload: error?.response?.data?.message || "Search failed",
        type: ERROR,
      };
  }
};

// httpRequest("get", `/jobs/${term}/search`)
//     .then(({ data: { data } }) => {
//       navigate();
//       const action = { type: SEARCH_JOBS, payload: { data, term } };
//       dispatch(action);
//       console.log(action);
//       return action;
//     })
//     .catch(({ response }) => {
//       cogoToast.error(`No result for ${term}`);
//       return {
//         payload: response?.data?.message,
//         type: ERROR,
//       };
//     });

export const deleteSavedJob = (dispatch, job_id) =>
  httpRequest("post", `/jobs/saved/${job_id}/delete`, {})
    .then(({ data: { data } }) => {
      const action = { type: DELETE_SAVED_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const deleteJob = (dispatch, jobid) => {
  //alert("deleting "+job.company_id);
  return httpRequest("post", `/jobs/${jobid}/delete`, {})
    .then(({ data: { data } }) => {
      const action = { type: DELETE_JOBS, payload: data };
      dispatch(action);
      cogoToast.success("Job deleted successfully!");
      return action;
    })
    .catch(({ response }) => {
      cogoToast.error(response?.data?.message || "Failed to delete job");
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });
};
export const likeUnlikeJob = (dispatch, data) =>
  httpRequest("post", "/jobs/like/likeUnLike", data)
    .then
    // ({ data: { data } }) => {
    // const action = { type: LIKE_UNLIKE_JOB, payload: data };
    // console.log("data payload", data);
    // dispatch(action);
    // return action;
    // }
    ()
    .catch(({ response }) => {
      // console.log("error res", response);
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getReferralJobs = (dispatch) =>
  httpRequest("get", `/insiight/referrals`)
    .then(({ data: { data } }) => {
      // console.log("in action");
      const action = { type: GET_REFERRAL_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getAdminJobs = (dispatch, page) =>
  httpRequest("get", `/admin/jobs/${page}/10`)
    .then(({ data: { data } }) => {
      // console.log("admin jobs", data);
      const action = { type: GET_ADMIN_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

// Get Single business job...
export const getBusinessJob = (dispatch, id) =>
  httpRequest("get", `/business/jobs/${id}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_BUSINESS_JOB, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getVerification = (dispatch, user_id) =>
  httpRequest("post", "/jobs/verify-user", { user_id })
    .then(({ data }) => {
      const isSuccess = data.success === true;
      const payload = { success: isSuccess };
      const action = { type: GET_VERIFICATION, payload };

      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
export const getPerformance = (dispatch, employee_id) =>
  httpRequest("get", `/employee-performance/${employee_id}`)
    .then(({ data }) => {
      const action = { type: GET_PERFORMANCE, payload: data };

      dispatch(action);

      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
export const getEachPerformance = (dispatch) =>
  httpRequest("get", "/employee-performance/")
    .then(({ data: { data } }) => {
      const action = { type: GET_EACHPERFORMANCE, data };

      dispatch(action);
      console.log(data);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getEmployee = (dispatch, id) =>
  httpRequest("get", `/employee-performance/supervisor-subordinates/${id}`)
    .then(({ data }) => {
      const action = { type: GET_EMPLOYEE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const postperformances = (dispatch, data) => {
  httpRequest("post", "/employee-performance/", data)
    .then(({ data }) => {
      const action = { type: POST_PERFORMANCE, payload: data };
      dispatch(action);
      getJobsAction(dispatch, 1);

      return action;
    })
    .catch(({ response }) => {
      // Dispatch an error action
      dispatch({ type: ERROR, payload: response?.data?.message });
    });
};
export const postemployeeperformance = (dispatch, data, employee_id) => {
  httpRequest("put", `/employee-performance/${employee_id}`, data)
    .then(({ data }) => {
      const action = { type: POST_EMPLOYEEPERFORMANCE, payload: data };
      dispatch(action);
      getJobsAction(dispatch, 1);

      return action;
    })
    .catch(({ response }) => {
      // Dispatch an error action
      dispatch({ type: ERROR, payload: response?.data?.message });
    });
};
export const editEmployee = (dispatch, profileId, data) => {
  httpRequest("put", `/employee-performance/${profileId}`, data)
    .then(({ data }) => {
      const action = { type: POST_EDITED_PERFORMANCE, payload: data };
      dispatch(action);
      getJobsAction(dispatch, 1);

      return action;
    })
    .catch(({ response }) => {
      // Dispatch an error action
      dispatch({ type: ERROR, payload: response?.data?.message });
    });
};
export const postsendback = (dispatch, data) => {
  httpRequest("post", "/employee-performance/send-back", data)
    .then(({ data }) => {
      const action = { type: POST_SENDBACK, payload: data };
      dispatch(action);

      return action;
    })
    .catch(({ response }) => {
      // Dispatch an error action
      dispatch({ type: ERROR, payload: response?.data?.message });
    });
};
export const postHiring = (dispatch, datas) =>
  httpRequest("post", "/jobs/candidate_recruitment", datas)
    .then(({ data }) => {
      const action = { type: POST_HIRING, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

    export const clearSearchAction = (dispatch) => {
  dispatch({
    type: "SEARCH_JOBS",
    payload: { term: "", data: [] }
  });
};